import { AbstractControl } from '@angular/forms';

export default function mustBeOneOf(setOfValidInputs: any[]) {
  return (control: AbstractControl) => {
    if (!setOfValidInputs.some(input => input === control.value)) {
      return {
        mustBeOneOf: true,
      };
    }
    return null;
  };
}
